module.exports = __webpack_public_path__ + "static/img/8.139181a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/8.png
// module id = 6Vsp
// module chunks = 0